import React from "react";
import { Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { $Empty } from "us.common/components";

export default Table